import { Component, input } from '@angular/core';

@Component({
    selector: 'section-card-skeleton',
    templateUrl: 'section-card-skeleton.component.html',
    styleUrl: 'section-card-skeleton.component.scss',
    standalone: true,
})
export class SectionCardSkeletonComponent {
    /** Espelha o modo rail da sidebar: só o avatar centralizado. */
    public collapsed = input(false);
}
